import React from 'react'
import {
    FormCell, CellBody, TextArea, CellFooter, Switch, Button,
    CellHeader, Label, Input, Toptips, Toast, Dialog, Form
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { WKGreenTitle } from '../../components/wk'
import { Page } from '../../components'
import {WKVisible, WKTextarea} from '../../components/wk'
import {isLZWKAPP} from '../../utils'
import {addSuccess} from '../../utils/connectApp'
import '../../css/page/ChannelCreatePage.css'


class ChannelCreatePage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            title: '',
            isMoney: false,
            money: '',
            isResell: false,
            resellPercent: '',
            isPending: false,
            channelId: '',
            expectedLectures: '',
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        document.title = '创建专栏'
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    bindValue (e, field) {
        const value = e.target.value
        this.setState({ [field]: value })
    }
    verify () {
        const { title, isMoney, money, isResell, resellPercent, expectedLectures } = this.state
        if (title.trim().length > 100 || title.trim().length < 1) {
            return { status: false, msg: '标题长度请控制在1-100个字符之间' }
        }
        if (isMoney) {
            if (money < 0.01) {
                return { status: false, msg: '专栏售价必须大于等于0.01' }
            }
            if (money > 100000) {
                return { status: false, msg: '专栏售价必须小于等于100000' }
            }
            if (isResell) {
                if (!/^\d+$/.test(resellPercent) || (resellPercent < 0 || resellPercent > 100)) {
                    return {
                        status: false,
                        msg: '比例为0到100的整数',
                    }
                }
                if (money * resellPercent / 100 < 0.01) {
                    return { status: false, msg: '价格*分成比例必须大于或等于0.01' }
                }
            }
        }
        if (expectedLectures.trim() === '' || !/^\d+$/.test(expectedLectures) || +expectedLectures < 1) {
            return { status: false, msg: '预计更新须填大于等于1的整数' }
        }
        return { status: true }
    }
    onSubmit () {
        const verifyRes = this.verify()
        if (!verifyRes.status) return this.showTip(verifyRes.msg)
        this.setState({ isPending: true })
        const { title, isMoney, money, isResell, resellPercent, expectedLectures } = this.state 
        let submitData = {
            name: title,
            need_money: isMoney,
            expected_lectures: +expectedLectures.trim(),
        }
        if (isMoney) {
            submitData = {
                money: (money * 100).toFixed(),
                ...submitData,
            }
            if (isResell) {
                submitData = {
                    resell_enabled: isResell,
                    resell_percent: resellPercent,
                    ...submitData,
                }
            }
        }
        axios.post(`/api/liveroom/${this.props.params.liveroom_id}/add_channel`, qs.stringify(submitData))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.setState({ channelId: res.data.data.channel_id })
                this.showAlert('创建成功')
            })
    }
    onClickSuccessOk () {
        if (isLZWKAPP()) {
            this.setState({ alertDialog: { isShow: false } })
            addSuccess('channel', this.state.channelId)
        } else {
            location.replace(`/channel/${this.state.channelId}`)
        }
    }
    render() {
        return (
            <Page>
                <div className="wk-inner-page channel-create-page">
                    <div className="page__hd">
                        <h1 className="page__title">创建专栏</h1>
                        <p className="page__desc">一个专栏可以包含多个直播、点播内容</p>
                    </div>
                    <WKGreenTitle title='专栏标题' />
                    <Form>
                        <FormCell>
                            <CellBody>
                                <WKTextarea 
                                    showCounter={true} 
                                    maxLength={100}
                                    placeholder="专栏标题1-100字符" 
                                    rows="3"
                                    value={this.state.title}
                                    onChange={e => this.bindValue(e, 'title')}
                                >
                                </WKTextarea>
                            </CellBody>
                        </FormCell>
                    </Form>
                    <p className="intro">1-100个字符，好的标题更容易吸引用户关注和购买</p>
                    <WKGreenTitle title='付费选项' />
                    <Form className="margin-bottom">
                        <FormCell switch>
                            <CellBody>设置价格</CellBody>
                            <CellFooter>
                                <Switch 
                                    checked={this.state.isMoney} 
                                    onChange={e => this.setState({ isMoney: e.target.checked })} 
                                />
                            </CellFooter>
                        </FormCell>
                        <WKVisible create={this.state.isMoney} tag={null}>
                            <FormCell>
                                <CellHeader>
                                    <Label>价格（元）</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input 
                                        className='text-right' 
                                        type="number" 
                                        placeholder="请输入专栏售价"
                                        value={this.state.money}
                                        onChange={e => this.bindValue(e, 'money')}
                                        disabled={!this.state.isMoney}
                                    />
                                </CellBody>
                            </FormCell>
                        </WKVisible>
                    </Form>
                    <WKVisible show={this.state.isMoney}>
                        <Form className="wk-bg-white margin-bottom">
                            <FormCell switch>
                                <CellBody>设置邀请奖励</CellBody>
                                <CellFooter>
                                    <Switch 
                                        checked={this.state.isResell} 
                                        onChange={e => this.setState({ isResell: e.target.checked })} 
                                    />
                                </CellFooter>
                            </FormCell>
                            <WKVisible create={this.state.isResell} tag={null}>
                                <FormCell>
                                    <CellHeader>
                                        <Label className='long-label'>分成比例（%）</Label>
                                    </CellHeader>
                                    <CellBody>
                                        <Input 
                                            className='text-right' 
                                            type="number" 
                                            pattern='[0-9]*'
                                            placeholder="请输入百分比"
                                            value={this.state.resellPercent}
                                            onChange={e => this.bindValue(e, 'resellPercent')}
                                            disabled={!this.state.isResell}
                                        />
                                    </CellBody>
                                </FormCell>
                            </WKVisible>
                        </Form>
                    </WKVisible>
                    {/* 预计更新 */}
                    <WKGreenTitle title='预计更新' />
                    <Form>
                        <FormCell>
                            <CellBody>
                                <Input 
                                    className='text-right' 
                                    type="number" 
                                    pattern='[0-9]*'
                                    placeholder=""
                                    value={this.state.expectedLectures}
                                    onChange={e => this.bindValue(e, 'expectedLectures')}
                                />
                            </CellBody>
                        </FormCell>
                    </Form>
                    <p className="intro">请填写本专栏内预计更新的课程数量</p>
                    <div className="wk-btn-90">
                        <Button onClick={() => this.onSubmit()}>创建专栏</Button>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickSuccessOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </Page>
        )
    }
}

export default ChannelCreatePage


// WEBPACK FOOTER //
// ./src/pages/channelCreate/ChannelCreatePage.js